import React from "react";

const TokenHyfye = () => {
  return (
    <section className="small_pb pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="token_rtinfo bg-white border_right">
              <div className="row text-center">
                
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="token_rt_value animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <h3>5 BNB</h3>
                    <p>Soft Cap Target</p>
                  </div>
                </div>

               
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="token_rt_value animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <h3>1 Trillion</h3>
                    <p>Total Supply</p>
                  </div>
                </div>

                

                <div className="col-lg-4 col-md-4 col-6">
                  <div className="token_rt_value animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                    <h3>BNB / USDT</h3>
                    <p>Accepted Currencies</p>
                  </div>
                </div>  

               

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TokenHyfye;
